import { useState } from "react";
import { ShieldCheck, Ban } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { StateTermsFields, useCompliance, complianceReady } from "./StateTermsFields";

export const ComplianceGate = ({ info, onDone }) => {
  const compliance = useCompliance();
  const [v, setV] = useState({ state: info?.state || "", age_confirmed: false, accept_terms: false, intermediary_ack: false });
  if (!info?.issue) return null;
  if (info.blocked) {
    return (
      <div data-testid="compliance-blocked" className="lux-card p-6 mt-8 flex items-center gap-4 border-rose-400/30">
        <Ban className="w-6 h-6 text-rose-300 shrink-0" />
        <p className="text-sm text-slate-300">{info.issue}. We'll let you know as soon as we launch there.</p>
      </div>
    );
  }
  const save = async () => {
    try {
      await api.put("/me/profile", v);
      toast.success("Thanks — you're all set");
      onDone();
    } catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div data-testid="compliance-gate" className="lux-card p-6 md:p-8 mt-8 border-[#38BDF8]/40 max-w-2xl">
      <p className="eyebrow"><ShieldCheck className="w-3.5 h-3.5 mr-1.5" />Before you join a line</p>
      <p className="text-slate-300 text-sm mt-4 mb-5">Please confirm where you live and accept our current terms.</p>
      <StateTermsFields value={v} onChange={setV} compliance={compliance} />
      <button data-testid="compliance-save-btn" disabled={!complianceReady(v, compliance)} onClick={save} className="btn-gold px-6 py-3 mt-5">Confirm</button>
    </div>
  );
};
